import { number, object } from "yup";
import { notifyCampaignAdmins } from "~/services/compensation-review/events/notifyCampaignAdmins";
import { notifyNextReviewerTurn } from "~/services/compensation-review/events/notifyNextReviewerTurn";
import { notifyOfPendingRecommendations } from "~/services/compensation-review/events/notifyOfPendingRecommendations";
import { notifyOfSendBack } from "~/services/compensation-review/events/notifyOfSendBack";
import { notifyReviewersOfCampaignClosed } from "~/services/compensation-review/events/notifyReviewersOfCampaignClosed";

/**
 * This is the main entry point for all events.
 * It is used to validate the event name and payload, and to get the listeners for the event.
 */
export const Events = {
  CompensationReview_CampaignClosed: object({
    campaignId: number().required(),
  }).required(),

  CompensationReview_RecommendationSentBack: object({
    campaignId: number().required(),
    recommendationId: number().required(),
  }).required(),

  CompensationReview_RecommendationSubmitted: object({
    campaignId: number().required(),
    recommendationId: number().required(),
  }).required(),
};

/**
 * This is the main entry point for all listeners.
 * It is used to validate the event name and payload, and to get the listeners for the event.
 */
export const Listeners = {
  CompensationReview_CampaignClosed: [notifyReviewersOfCampaignClosed],

  CompensationReview_RecommendationSentBack: [notifyOfSendBack],

  CompensationReview_RecommendationSubmitted: [
    notifyNextReviewerTurn,
    notifyOfPendingRecommendations,
    notifyCampaignAdmins,
  ],
};
